<template>
  <v-container fluid fill-height grid-list-md style="padding:0px 10px 10px 10px; height:100%; width:100%; background-color:white;">
    <v-layout v-if="fault!=undefined" column>
      <div style="width:100%; height:48px; display:flex; align-items:center;">
        <span v-if="AtoB" style="font-size: 16px; font-weight: bolder;">Date: {{ date }}</span>
        <v-radio-group v-model="dataType" row style="display:flex; justify-content:flex-end; align-items:center;">
          <v-radio flat value="values" label="Values" color="rgb(51,82,128)"/>
          <v-radio flat value="diff" label="Diff. %" color="rgb(51,82,128)"/>
        </v-radio-group>
      </div>
      <v-layout id="faultDetailGraphs" row>
        <v-flex d-flex md6 style="padding: 0px 4px;">
          <v-layout column>
            <v-flex ref="tlChart" v-for="n in 3" :key="n" d-flex md4 style="max-height:calc(100% / 3);">
              <TimelineChart v-bind:active="active" v-bind:chartOptions="chartData[params[n-1]]" v-bind:title="titles[params[n-1]]"/>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex d-flex md6 style="padding: 0px 4px;">
          <v-layout column>
            <v-flex v-for="n in 3" :key="n" d-flex md4 style="max-height:calc(100% / 3);">
              <TimelineChart v-bind:active="active" v-bind:chartOptions="chartData[params[n+2]]" v-bind:title="titles[params[n+2]]"/>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-layout>
    <div v-else style="width:100%; height:100%; background-color:white; display:flex; justify-content:center; align-items:center;">
      <v-img :src="require('../assets/check-mark-circle3.png')" contain height="200"></v-img>
    </div>
  </v-container>
</template>

<script>

import TimelineChart from '../controls/TimelineChart'
import axios from 'axios';

import {globalStore, vessels} from "../main.js"

export default {
  name: 'EngineFaultsDetails',
  components: {
    TimelineChart
  },
  props: {
    active: Boolean,
    fault: Object,
    history: Boolean
  },
  data() {
    return {
      chartData: {},
      dataType: 'values',
      titles: {},
      params: [],
      mapParams: [],
      queriedDates: {}
    }
  },
  mounted() {
    this.setData();
  },
  methods: {
    average: function (param, data) {
      if (Object.keys(data).includes(param))
        return data[param];

      let sum = 0,
          count = 0,
          index = 1,
          paramExists = true;

      while (paramExists) {
        if (Object.keys(data).includes(param + index)) {
          if ((data[param + index] != -1000) && (data[param + index] != 0)) {
            sum += data[param + index];
            count++;
          }

          index++;
        } else
          paramExists = false;
      }

      if ((sum == 0) || (count == 0))
        return -1000;
      else
        return sum / count;
    },
    setData() {
      if (typeof this.fault != 'undefined') {
        var mapping = globalStore.mapping[globalStore.selectedIMO];

        if (typeof mapping == 'undefined') {
          mapping = globalStore.mapping[Object.keys(globalStore.mapping)[0]]
        }

        let vessel = vessels.vessels.filter((vessel) => {
          return vessel.imo == globalStore.selectedIMO
        });

        if (!vessel.length) {
          return;
        }

        let code = null,
            index = this.fault.index,
            control = vessel[0].control;

        if (typeof this.fault.events != 'undefined') {
          code = this.fault.events[0].code;
        }

        switch (control) {
          case 0:
            control = 'UNIC';
            break;
          case 1:
            control = 'WECS';
            break;
          case 2:
            control = 'WICE';
            break;
        }

        let param_row;
        if (code != null) {
          param_row = globalStore.faultMapping[`${code}_${control}`] || globalStore.faultMapping[code];

          this.params = param_row.map(item => {
            if (item.startsWith('GAVduration')) {
              if (this.fault.subComponent.includes('Fuel'))
                return 'GAVfuelDuration' + index;
              else
                return 'GAVexhaustDuration' + index;
            } else {
              return item.replace('%s', (index > 0 ? index : ''));
            }
          });

          this.mapParams = param_row.map(item => {
            return item.replace('%s', '');
          });
        }

        //var vessel = Object.values(vessels.vessels).find(item=>item.imo == globalStore.selectedIMO);

        for (let p = 0; p < this.mapParams.length; p++) {
          if (this.mapParams[p].startsWith('GAVduration')) {
            if (this.fault.subComponent.includes('Fuel')) this.$set(this.titles, this.params[p], 'GAV Duration Fuel Side ' + index);
            else this.$set(this.titles, this.params[p], 'GAV Duration Exhaust Side ' + index);

          } else if (!!param_row[p] && param_row[p].includes('%s')) {
            this.$set(this.titles, this.params[p], mapping['mapping'][this.mapParams[p]] + ' ' + index);
          } else {
            this.$set(this.titles, this.params[p], mapping['mapping'][this.mapParams[p]]);
          }
        }

        if (this.dataType == 'values') {
          this.setValuesData();
        }else {
          this.setDiffData();
        }
      }

      globalStore.loading = false;
    },
    async setValuesData() {
      if (typeof this.fault.events == 'undefined') {
        return null;
      }

      var date = this.fault.events[0].Date.split('T')[0],
          faultDateSignals = globalStore.signals,
          faultDateReferences = globalStore.reference;

      if (this.history) {
        if (typeof this.queriedDates[date] == 'undefined') {
          let url = globalStore.config.api_location + '/vessel/GetVesselInfo/' + globalStore.selectedIMO + '/' + date,
              response = await axios.get(url, {headers: {Authorization: globalStore.auth_token}});

          if (typeof response != 'undefined' && response.status == 200) {
              faultDateSignals = response.data.data.signal;
              faultDateReferences = response.data.data.reference;
          }

          this.queriedDates[date] = {
            sigs: faultDateSignals,
            reference: faultDateReferences
          }
        } else {
          faultDateSignals = this.queriedDates[date].sigs;
          faultDateReferences = this.queriedDates[date].reference;
        }

        if (globalStore.twinEngine) {
          faultDateSignals = faultDateSignals[globalStore.selectedEngine];
          faultDateReferences = faultDateReferences[globalStore.selectedEngine];
        }
      }

      let timeStamps = Object.keys(faultDateSignals);

      var units = globalStore.units[globalStore.selectedIMO];

      if (typeof units == 'undefined') {
        units = globalStore.units[Object.keys(globalStore.units)[0]]
      }

      if (timeStamps.indexOf('average') > -1)
        timeStamps.splice(timeStamps.indexOf('average'), 1);

      for (let p = 0; p < this.params.length; p++) {
        this.$set(this.chartData, this.params[p], {
          credits: {enabled: false},
          time: {
            useUTC: true
          },
          chart: {
            height: 100,
            zoomType: 'xy'
          },
          xAxis: {
            type: 'datetime',
            title: {
              text: 'Time',
              align: 'high'
            },
            labels: {
              format: '{value:%H:%M}'
            },
            crosshair: true,
            plotLines: (() => {
              var startDate = new Date(this.fault.events[0].Date + '.000Z'),
                  endDate = new Date(this.fault.events[this.fault.events.length - 1].Date + '.000Z'),
                  color = ((this.fault.color == 20) ? '#CB3725' : '#FFA400');

              return [
                {
                  color: color,
                  width: 1,
                  value: startDate//new Date(this.fault.events[0].Date)
                },
                {
                  color: color,
                  width: 1,
                  value: endDate//new Date(this.fault.events[this.fault.events.length - 1].Date)
                }
              ]
            })()
          },
          yAxis: {
            title: {
              text: '[' + units[this.mapParams[p]] + ']',
              align: 'high'
            }
          },
          exporting: {
            enabled: false
          },
          tooltip: {
            formatter: function () {
              var s = '<b>' + new Date(this.x).toISOString().substring(0, 16).replace('T', ' ') + '</b>',
                  actTime = this.x, allSeries = [];

              if (this.points) {
                allSeries = this.points[0].series.chart.series
              } else {
                allSeries = this.point.series.chart.series;
              }

              allSeries.forEach(series => {

                if (series.name != 'State') {
                  var diff = series.closestPointRange, actPoint = null;

                  series.data.forEach(point => {
                    let temp = Math.abs(actTime - point.x)

                    if ((diff == null) || (temp < diff)) {
                      actPoint = point;
                      diff = temp;
                    }
                  });

                  if (actPoint != null) {
                    if (actPoint.series.type == 'scatter') {
                      s += '<br/> ' + actPoint.series.name + ': ' + actPoint.y.toFixed(2);
                    } else {
                      s += '<br/> ' + actPoint.series.name + ': from ' + actPoint.low.toFixed(2) + ' to ' + actPoint.high.toFixed(2);
                    }
                  }
                }
              });
              return s;
            },
            shared: true
          },
          legend: {
            enabled: false
          },
          title: {
            text: undefined
          },
          series: [
            {
              name: 'Value',
              type: 'scatter',
              color: 'transparent',
              animation: false,
              data: [],
              marker:
                  {
                    radius: 3,
                    enabled: true
                  },
              states: {
                hover: {
                  enabled: false
                },
                normal: {
                  animation: false
                },
                inactive: {
                  opacity: 1
                }
              }
            },
            {
              name: 'Acceptable Range',
              type: 'arearange',
              animation: false,
              data: [],
              marker: {
                enabled: false
              },
              color: 'rgb(219, 219, 219)',
              fillOpacity: 0.6,
              states: {
                hover: {
                  enabled: false
                },
                normal: {
                  animation: false
                },
                inactive: {
                  opacity: 1
                }
              }
            }
          ]
        });

        this.pushValuesData(faultDateSignals, faultDateReferences, this.params[p], this.mapParams[p]);
      }
    },
    async setDiffData() {
      var date = this.fault.events[0].Date.split('T')[0],
          faultDateSignals = globalStore.signals,
          faultDateReferences = globalStore.reference;

      if (this.history) {
        if (typeof this.queriedDates[date] == 'undefined') {
          //let url = globalStore.config.api_location + '/GetWiDEDataWithDashesPerVessel/' + globalStore.selectedIMO + '/' + date + '/';
          let url = globalStore.config.api_location + '/vessel/GetVesselInfo/' + globalStore.selectedIMO + '/' + date;

          //let response = await axios.get(url + '_sig');
          let response = await axios.get(url, {headers: {Authorization: globalStore.auth_token}});

          if (typeof response != 'undefined' && response.status == 200) {
            faultDateSignals = response.data.data.signal;
            faultDateReferences = response.data.data.reference;
          }

          this.queriedDates[date] = {
            sigs: faultDateSignals,
            reference: faultDateReferences
          }
        } else {
          faultDateSignals = this.queriedDates[date].sigs;
          faultDateReferences = this.queriedDates[date].reference;
        }

        if (globalStore.twinEngine) {
          faultDateSignals = faultDateSignals[globalStore.selectedEngine];
          faultDateReferences = faultDateReferences[globalStore.selectedEngine];
        }
      }

      let timeStamps = globalStore.signals.timestamps;

      if (timeStamps.indexOf('average') > -1)
        timeStamps.splice(timeStamps.indexOf('average'), 1);

      for (let p = 0; p < this.params.length; p++) {
        this.$set(this.chartData, this.params[p], {
          credits: {enabled: false},
          time: {
            useUTC: true
          },
          chart: {
            height: 100,
            zoomType: 'xy'
          },
          xAxis: {
            type: 'datetime',
            title: {
              text: 'Time',
              align: 'high'
            },
            labels: {
              format: (() => {
                return ((typeof globalStore.dateTo == 'undefined' || globalStore.dateTo.length < 1) ? '{value:%H:%M}' : '{value:%m-%e}')
              })(),
            },
            crosshair: true,
            plotLines: (() => {
              var startDate = new Date(this.fault.events[0].Date + '.000Z'),
                  endDate = new Date(this.fault.events[this.fault.events.length - 1].Date + '.000Z'),
                  // diff = Math.abs(endDate - startDate),
                  // minutes = Math.floor((diff / 1000) / 60),
                  color;

              if (this.fault.color == 20)
                color = '#CB3725';
              else
                color = '#FFA400';

              //if (minutes >= 5) {
              return [
                {
                  color: color,
                  width: 1,
                  value: startDate //= new Date(this.fault.events[0].Date+'.000Z'),

                },
                {
                  color: color,
                  width: 1,
                  value: endDate
                }
              ]
            })()
          },
          yAxis: {
            title: {
              text: '[%]',
              align: 'high'
            }
          },
          exporting: {
            enabled: false
          },
          tooltip: {
            formatter: function () {
              var s = '<b>' + new Date(this.x).toISOString().substring(0, 16).replace('T', ' ') + '</b>',
                  actTime = this.x, allSeries = [];

              if (this.points) {
                allSeries = this.points[0].series.chart.series
              } else {
                allSeries = this.point.series.chart.series;
              }

              allSeries.forEach(series => {

                if (series.name != 'State') {
                  var diff = series.closestPointRange, actPoint = null;

                  series.data.forEach(point => {
                    let temp = Math.abs(actTime - point.x)

                    if ((diff == null) || (temp < diff)) {
                      actPoint = point;
                      diff = temp;
                    }
                  });

                  if (actPoint != null) {
                    if (actPoint.series.type == 'scatter') {
                      s += '<br/> ' + actPoint.series.name + ': ' + actPoint.y.toFixed(2);
                    } else {
                      s += '<br/> ' + actPoint.series.name + ': from ' + actPoint.low.toFixed(2) + ' to ' + actPoint.high.toFixed(2);
                    }
                  }
                }
              });
              return s;
            },
            shared: true
          },
          legend: {
            enabled: false
          },
          title: {
            text: undefined
          },
          series: [
            {
              name: 'Value',
              type: 'scatter',
              animation: false,
              data: [],
              marker: {
                radius: 3
              },
              states: {
                hover: {
                  enabled: false
                },
                normal: {
                  animation: false
                },
                inactive: {
                  opacity: 1
                }
              }
            },
            {
              name: 'Acceptable Range',
              type: 'arearange',
              animation: false,
              data: [],
              marker: {
                enabled: false
              },
              color: 'rgb(219, 219, 219)',
              fillOpacity: 0.6,
              states: {
                hover: {
                  enabled: false
                },
                normal: {
                  animation: false
                },
                inactive: {
                  opacity: 1
                }
              }
            }
          ]
        });

        await this.pushDiffData(faultDateSignals, faultDateReferences, this.params[p], this.mapParams[p]);
      }
    },
    pushValuesData(signals, refs, params, mapParams) {

      var limits = globalStore.limits[globalStore.selectedIMO];

      if (typeof limits == 'undefined') {
        limits = globalStore.limits[Object.keys(globalStore.limits)[0]]
      }

      let timeStamps = Object.keys(signals);

      timeStamps = timeStamps.slice(0, timeStamps.length - 1);

      for (var i in timeStamps) {
        if (timeStamps.hasOwnProperty(i)) {
          var timestamp = timeStamps[i];

          let val, rfr;

          if (Object.keys(signals[timestamp]).includes(params))
            val = signals[timestamp][params];
          else
            val = this.average(params, signals[timestamp]);

          if (params == 'fRailPres')
            rfr = signals[timestamp]['fRailPresSet'];
          else if (params == 'soPresDispl')
            rfr = signals[timestamp]['soPresSetpoint'];
          else if (Object.keys(refs).includes(timestamp)) {
            if (Object.keys(refs[timestamp]).includes(params))
              rfr = refs[timestamp][params];
            else
              rfr = this.average(params, refs[timestamp]);
          } else
            rfr = -1000;

          let color = 'rgb(51,82,128)',
              dt = new Date(timestamp);

          if (dt == 'Invalid Date') {
            dt = new Date(parseInt(timestamp))
          }

          if (dt != 'Invalid Date' && val != -1000 && rfr != -1000 && typeof limits[mapParams] != 'undefined') {

            let minLimit = limits[mapParams][0],
                maxLimit = limits[mapParams][1];

            if (minLimit != null && maxLimit != null) {
              let temp = ((val - rfr) / val) * 100;

              if (temp > minLimit && temp < maxLimit)
                color = 'rgb(60, 171, 48)';
              else
                color = 'rgb(205, 57, 64)';

              let min = rfr / (1 - minLimit / 100),
                  max = rfr / (1 - maxLimit / 100);

              this.chartData[params].series[1].data.push({
                x: dt,
                low: min,
                high: max
              });
            }
          }

          if (dt != 'Invalid Date' && val != -1000) {
            this.chartData[params].series[0].data.push({
              x: dt,
              y: val,
              color: color
            });
          }
        }
      }
    },
    pushDiffData(signals, refs, params, mapParams) {
      var limits = globalStore.limits[globalStore.selectedIMO];

      if (typeof limits == 'undefined') {
        limits = globalStore.limits[Object.keys(globalStore.limits)[0]]
      }

      let timeStamps = Object.keys(signals);

      timeStamps = timeStamps.slice(0, timeStamps.length - 1);

      for (var i in timeStamps) {
        if (timeStamps.hasOwnProperty(i)) {
          var timestamp = timeStamps[i];

          let val, rfr;

          if (Object.keys(signals[timestamp]).includes(params))
            val = signals[timestamp][params];
          else
            val = this.average(params, signals[timestamp]);

          if (params == 'fRailPres')
            rfr = signals[timestamp]['fRailPresSet'];
          else if (params == 'soPresDispl')
            rfr = signals[timestamp]['soPresSetpoint'];
          else if (Object.keys(refs).includes(timestamp)) {
            if (Object.keys(refs[timestamp]).includes(params))
              rfr = refs[timestamp][params];
            else
              rfr = this.average(params, refs[timestamp]);
          } else
            rfr = -1000;

          let color = 'rgb(51,82,128)',
              dt = new Date(timestamp);

          if (dt == 'Invalid Date') {
            dt = new Date(parseInt(timestamp))
          }

          if ((dt != 'Invalid Date') && (val != -1000) && (rfr != -1000) && (Object.keys(limits).includes(mapParams))) {
            let minLimit = limits[mapParams][0],
                maxLimit = limits[mapParams][1],
                temp = ((val - rfr) / val) * 100;

            if ((minLimit != null) && (maxLimit != null)) {
              if ((temp > minLimit) && (temp < maxLimit))
                color = 'rgb(60, 171, 48)';
              else
                color = 'rgb(205, 57, 64)';

              this.chartData[params].series[1].data.push({
                x: dt,
                low: minLimit,
                high: maxLimit
              });
            }

            this.chartData[params].series[0].data.push({
              x: dt,
              y: temp,
              color: color
            });
          }
        }
      }
    }
  },
  computed: {
    dataLoaded: function () {
      return globalStore.type;
    },
    cylCount: function () {
      return globalStore.cylCount;
    },
    tcCount: function () {
      return globalStore.tcCount;
    },
    date: function () {
      return this.fault.endDate.split(/\s|T/)[0];
    },
    selectedIMO: function () {
      return globalStore.selectedIMO;
    }
    // AtoB: function () {
    //     this.isAtoB = typeof globalStore.dateTo != 'undefined' && !!globalStore.dateTo.length;

    //     return this.isAtoB;
    // }
  },
  watch: {
    fault: function () {
      this.setData();
    },
    dataType: function () {
      this.setData();
    },
    dataLoaded: function () {
      this.setData();
    },
    active: function () {
      this.setData();
    },
    selectedIMO: function () {
      if (!!globalStore.selectedIMO) {
        this.setData();
      }
    }
  }
}
</script>

<style>
#faultDetailGraphs {
  max-height: 95%;
}
</style>